'use client';
import { useState } from 'react';
import ImageComparisonSlider from '@/components/ImageComparisonSlider';
import { useTranslations } from 'next-intl';

type TabContent = {
  [key: string]: string[];
};

interface StunQualityProps {
  title?: string;
  defaultTab?: string;
}

const tabContent: TabContent = {
  Portrait: [
    'https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/02f0b387-f83d-4343-11ed-f5b2412a0300/public',
    'https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/44980bf2-e467-4b04-80a6-1e0f8b77c300/public',
  ],
  Childhood: [
    'https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/d344d92b-4fb9-4e8c-c190-910a43ec0000/public',
    'https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/ce8bce8f-baf8-461a-8a3e-5ddb3d8a3b00/public',
  ],
  Wedding: [
    'https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/d9b56372-e198-45b8-0c3d-a88a83ffdb00/public',
    'https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/0d65e4ee-c9b3-4153-0ba9-2dea478e6d00/public',
  ],
  Family: [
    'https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/0156f915-6754-401d-0c6a-fd341d417f00/public',
    'https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/9b77e74b-4cd3-4488-37a6-8691f8ae7800/public',
  ],
  Graduation: [
    'https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/6df9c886-0d90-48e7-bebf-beb48b8dfa00/public',
    'https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/86ef82ae-b6ec-4633-1ca1-dab4e0d81800/public',
  ],
  Event: [
    'https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/fd719b10-c6c9-4fc1-0f47-2c6840d45800/public',
    'https://imagedelivery.net/7rExjEZEypWvglDwZ5-zxA/ed08db89-6099-440d-4970-09517e8c9f00/public',
  ],
};

// 获取默认标签的key
const getDefaultTabKey = (defaultTab: string): string => {
  const tabKeys = Object.keys(tabContent);
  return tabKeys.find((key) => key === defaultTab) || 'Portrait';
};

const StunQuality = ({
  title = 'Old Photos. New Emotions.',
  defaultTab = 'Portrait',
}: StunQualityProps) => {
  const t = useTranslations('PhotoRestoration.stunQuality');
  const [activeTab, setActiveTab] = useState(getDefaultTabKey(defaultTab));

  return (
    <section className='section-container mt-0 items-start md:items-center lg:mt-20'>
      <h2 className='w-full text-center text-2xl font-semibold md:text-[44px]'>
        {title}
      </h2>
      <div className='tabs mt-7 grid grid-flow-col grid-rows-2 justify-start gap-1 md:mt-12 md:grid-rows-1 md:justify-center md:gap-4'>
        {Object.keys(tabContent).map((tab) => (
          <button
            key={tab}
            className={`h-fit w-fit rounded-full px-5 py-[6px] text-base font-medium text-gray-800 ${
              activeTab === tab ? 'active bg-gray-800 text-white' : ''
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {t(`tabs.${tab}`)}
          </button>
        ))}
      </div>
      <div className='mt-12 w-full'>
        <ImageComparisonSlider
          key={activeTab}
          afterImage={tabContent[activeTab][0]}
          beforeImage={tabContent[activeTab][1]}
          width={600}
          height={400}
        />
      </div>
    </section>
  );
};

export default StunQuality;
